import {
  ButtonOneTapAuthOptions,
  Config,
  Connect,
  ConnectEvents,
  FloatingOneTapAuthOptions,
  VKOneTapAuthButtonResult,
  VKOneTapAuthResult,
} from '@vkontakte/superappkit'

import { CallbackHandler, CallbackType } from '@/services/vkAuth/vkAuth.types'
import { Success } from '@/api/results'

export class VkAuthService {
  private oneTapButton: VKOneTapAuthResult | VKOneTapAuthButtonResult | null =
    null

  private oneTapButtonOptions: ButtonOneTapAuthOptions = {
    showAlternativeLogin: false,
    displayMode: 'name_phone',
    buttonStyles: {
      borderRadius: 10,
    },
  }

  private floatingButtonOptions: FloatingOneTapAuthOptions = {
    skipSuccess: true,
    styles: {
      zIndex: 999,
    },
  }

  // Инициализация VK авторизации
  init(token: number | undefined) {
    try {
      Config.init({ appId: token || undefined })

      return new Success()
    } catch (error) {
      return new Error(error)
    }
  }

  // Callback, который будет вызван после нажатия на кнопку VK
  callbackAuthHandler(
    type: CallbackType,
    payload,
    callback: CallbackHandler,
    redirectUrl: string,
  ) {
    switch (type) {
      case ConnectEvents.OneTapAuthEventsSDK.LOGIN_SUCCESS:
        // eslint-disable-next-line n/no-callback-literal
        return callback({
          uuid: payload?.uuid || '',
          token: payload?.token || '',
          first_name: payload?.user?.first_name || '',
        })
      case ConnectEvents.OneTapAuthEventsSDK.FULL_AUTH_NEEDED:
      case ConnectEvents.OneTapAuthEventsSDK.PHONE_VALIDATION_NEEDED:
      case ConnectEvents.ButtonOneTapAuthEventsSDK.SHOW_LOGIN:
        Connect.redirectAuth({
          url: window.location.origin + '/redirect/',
          state: redirectUrl || window.location.origin,
        })
    }
  }

  // Вызов быстрой авторизации VK
  authByOneTapButton(callback: CallbackHandler, url: string) {
    this.oneTapButton = Connect.buttonOneTapAuth({
      callback: ({ type, payload }) =>
        this.callbackAuthHandler(type, payload, callback, url),
      options: this.oneTapButtonOptions,
    })
  }

  // Вызов безшовной авторизации VK
  authByFloatingButton(callback: CallbackHandler, url: string) {
    this.oneTapButton = Connect.floatingOneTapAuth({
      callback: ({ type, payload }) =>
        this.callbackAuthHandler(type, payload, callback, url),
      options: this.floatingButtonOptions,
    })
  }

  // Встраиваем кнопку VK в переданный блок
  setIframe(parentNode: Node) {
    const iframeNodeElement = this.oneTapButton?.getFrame()

    if (iframeNodeElement) parentNode.appendChild(iframeNodeElement)
  }
}
